<template>
  <div>
    <learnCardBind :value.sync="showLearnCardBind"></learnCardBind>
    <div class="nupmrm_case">
      <div class="npm_caseDiv9" style="height: 38px;">
        <div class="npm_caseDiv9_left">练习状态：</div>
        <div class="npm_caseDiv9_right">
          <ul class="i_nav-012">
            <el-radio-group v-model="searchForm.state" @change="searchList" size="medium">
              <el-radio-button label="">全部</el-radio-button>
              <el-radio-button label="2">已练</el-radio-button>
              <el-radio-button label="3">未练</el-radio-button>
              <el-radio-button label="4">已结束</el-radio-button>
            </el-radio-group>
          </ul>
        </div>
      </div>
      <div class="npm_caseDiv9" style="height:38px; text-align:left;padding-left: 0;" >
        <div class="npm_caseDiv9_right">
          <span v-show="bindType == 2">培训班：</span><el-select v-model="searchForm.trainingId" size="small" style="width:20%; margin-right: 100px;" v-show="bindType == 2">
          <el-option  label="全部" value=""></el-option>
          <el-option
            v-for="item in nameReturn"
            :label="item.name"
            :value="item.id"
            :key="item.id">
          </el-option>
        </el-select>
          练习名称：<el-input v-model.trim="searchForm.name" placeholder="按练习名称关键字搜索"  style="width:20%; margin-right: 100px;" size="small"></el-input>
          <input type="button" value="搜索" id="search" @click="searchList" />
        </div>
      </div>
    </div>
    <div class="nupmrm_content">
      <el-table :data="practiseListInit" highlight-current-row v-loading="listLoading" style="width: 100%;" border size="mini" @sort-change="sortPractiseList">
        <el-table-column prop="name" label="练习名称" width="294"></el-table-column>
        <el-table-column prop="endTime" label="练习有效期"  width="300">
          <template slot-scope="scope">
            <span class='w295 c-999  pr'>{{scope.row.startTime}}至{{scope.row.endTime}}<img v-if="serverTime >scope.row.endTime" src='../assets/images/kaoshijieshu.png' width='54' height='26' border='0' class='new_pic_yjs' /></span>
          </template>
        </el-table-column>
        <el-table-column prop="paperQuestionSum" label="试题数" width="100"></el-table-column>
        <el-table-column prop="testCount" label="已练次数" width="100"></el-table-column>
        <el-table-column prop="highestScore" sortable="custom"  label="成绩" :formatter="formatScore" width="98"></el-table-column>
        <el-table-column label="操作" width="106">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="beginPractise(scope.$index, scope.row)"  :disabled="serverTime > scope.row.endTime || serverTime < scope.row.startTime" >开始练习</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-col :span="24" class="toolbar" style="padding-top: 12px;">
        <el-pagination layout="total, prev, pager, next" @current-change="handlePractiseCurrentChange" :page-size="searchForm.pageSize" :total="searchForm.total" style="float:right;" :current-page="searchForm.page">
        </el-pagination>
      </el-col>
    </div>

    <!--导出提示框··开始-->
    <el-dialog title="提示" :visible.sync="openPractiseVisible" :close-on-click-modal="false" width="30%">
      <el-form ref="openForm"  :inline="true" >
        <el-form-item  label="要继续上次的练习吗">
        </el-form-item>
        <br>
        <el-form-item label-width="250px">
          <el-button type="primary" @click="openOldPractise">确定</el-button>
          <el-button @click="openNewPractise">开始新的练习</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<style>

</style>

<script>
  import util from '../common/js/util'
  import { mapGetters } from 'vuex'
  import jsonp from 'jsonp'
  import md5 from 'crypto-js/md5'
  import { getServerNowTime,getBeginPracticeUrl,listStudentTraining,getUserCenterPractiseLists,validateUserCreditBindingTerm} from '../api/api'

  import learnCardBind from '../components/LearnCardBind'

  export default {
    components: {
      learnCardBind
    },
    props: {
      bindType: {
        type: String,
        required: false
      }
    },
    data () {
      return {
        showLearnCardBind : false,
        practiseListInit:[],
        listLoading:false,
        openPractiseVisible:false,
        serverTime:'',
        nameReturn:[],
        practiseId:'',
        searchForm:{
          page: 1,//当前页数
          pageSize: 10,//每页显示条目个数
          total: 0, //总条目数
          state:'',
          psort:'',
          name:'',
          trainingId:'',
          userId:'',
          bindType:''
        },
      }
    },
    computed: {
      ...mapGetters([
        'userInfo'
      ])
    },
    methods: {

      getTrainingNameList(){
        listStudentTraining({//获得学员所有培训班
          userId: this.userInfo.id,
          excludeExpire: false,
          trainingWay:'1'
        }).then((response) => {
          this.nameReturn = response.data.data.list
        })
      },

      searchList(){
        this.searchForm.page = 1;
        this.listMyPractiseInit();
      },

      sortPractiseList({ column, prop, order }){
        if(order == 'ascending'){  //正序
          this.searchForm.psort=1;
        }else if(order == 'descending'){  //倒序
          this.searchForm.psort=0;
        }
        this.listMyPractiseInit();
      },

      listMyPractiseInit(){
        if(!this.$storejs.get(process.env.APPKEY + 'token')){
          this.$alert('请刷新检查登陆状态', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$router.push("/");
            }
          });
          return false;
        }

        this.listLoading = true;

        var param = {userId:this.userInfo.id,page:this.searchForm.page,pageSize:this.searchForm.pageSize,state:this.searchForm.state,bindType:this.bindType,trainingId:this.searchForm.trainingId,name:this.searchForm.name,psort:this.searchForm.psort};
        getUserCenterPractiseLists(param).then((res) => {
          this.searchForm.total = res.data.total;
          this.practiseListInit = res.data.data;
          this.serverTime = this.$moment(res.data.ts).format('YYYY-MM-DD HH:mm:ss');// util.formatDate.format(new Date(data.ts),'yyyy-MM-dd hh:mm:ss');
          this.listLoading = false;
        }).catch(() => {
          this.listLoading = false
          this.$message({
            type: 'info',
            message: '加载失败！'
          });
        });

        /*jsonp(process.env.EXAM_API_URL + 'v2/practices/user/' + this.userInfo.id + '?' +'page=' +
          this.searchForm.page+'&pageSize=' + this.searchForm.pageSize+'&state=' + this.searchForm.state+'&psort=' + this.searchForm.psort+'&bindType='+this.bindType+'&trainingId='+this.searchForm.trainingId
          +'&name=' + this.searchForm.name
          , (err, data) => {
            if(data.data !=null ){
              this.searchForm.total = data.total;
              this.practiseListInit = data.data;
            }else{
              this.searchForm.total = 0;
              this.practiseListInit = [];
            }
            this.serverTime =this.$moment(data.ts).format('YYYY-MM-DD hh:mm:ss'); //  util.formatDate.format(new Date(data.ts),'yyyy-MM-dd hh:mm:ss');
            this.listLoading = false;
          });*/
      },

      handlePractiseCurrentChange(val){
        this.searchForm.page = val;
        this.listMyPractiseInit();
      },

      /****************************************************开始练习的方法*****************************************************/
      beginPractise(index,row){
        if(!this.$storejs.get(process.env.APPKEY + 'token')){
          this.$alert('请刷新检查登陆状态', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$router.push("/");
            }
          });
          return false;
        }

        let newWindow = window.open("",'practiceOnly');
        validateUserCreditBindingTerm({
          trainingIds:row.trainingStatus,
          userId: this.userInfo.id,
        }).then((response) => {
          if(response.data == false ){
            newWindow.close()
            this.showLearnCardBind = true;
          }else{
            this.practiseId = row.id;
            if(row.testCount >=1){
              newWindow.close()
              this.openPractiseVisible = true;
            }else{
              getServerNowTime().then((response) => {
                var nowDate = new Date(response.data);

                var begin = new Date(row.startTime.replace(/\-/g, "\/"));

                if(nowDate < begin){
                  newWindow.close();
                  this.$alert('暂未到练习开始时间', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                    }
                  });
                  return false;
                }else{
                  getBeginPracticeUrl({userId: this.userInfo.id,createNew:1,practiceId:this.practiseId}).then((response) => {
                    newWindow.location = response.data;
                  })
                }
              })
            }
          }
        })
      },

      openNewPractise(){

        let newWindow = window.open("",'practiceOnly');
        getServerNowTime().then((response) => {
          var nowDate = new Date(response.data);

          //var practiseUrl = this.createPractiseUrl(1,this.practiseId,nowDate );
          this.openPractiseVisible = false;
          setTimeout(() => {
            getBeginPracticeUrl({userId: this.userInfo.id,createNew:1,practiceId:this.practiseId}).then((response) => {
              newWindow.location = response.data;
            })
          }, 200);
        })

      },

      openOldPractise(){

        let newWindow = window.open("",'practiceOnly');
        getServerNowTime().then((response) => {
          var nowDate = new Date(response.data);
          //var practiseUrl = this.createPractiseUrl(0,this.practiseId,nowDate );

          this.openPractiseVisible = false;
          setTimeout(() => {
            getBeginPracticeUrl({userId: this.userInfo.id,createNew:0,practiceId:this.practiseId}).then((response) => {
              newWindow.location = response.data;
            })
          }, 200);
        })
      },

      formatScore: (row, column)=> {
        if(row.highestScore == ''  || row.highestScore ==null || row.highestScore == undefined)
          return '-' ;
        else
          return row.highestScore ;

      },

      formatTime: (row, column)=> {
        return row.startTime +"至"+ row.endTime ;
      },

      /* createPractiseUrl(isNew,practiseId,date){
       var ts = date.getTime().toString();
       let fp = md5(this.userInfo.id + ts + "usercenter").toString().toUpperCase();

       let reUrl = process.env.PRACTISE_URL + "api/user/login/oauth2"
       + "?" + "turl=" + encodeURIComponent(process.env.PRACTISE_URL + "online/practice/practice.html?createNew=" + isNew) //开始练习的地址
       + "&" + "eurl=" + encodeURIComponent(process.env.WEB30_URL + "MyPractise") // 练习结束回调地址
       + "&" + "ts=" + ts
       + "&" + "from=" + "usercenter"
       + "&" + "fp=" + fp
       + "&" + "userId=" + this.userInfo.id
       + "&" + "practiceId=" + practiseId;

       return reUrl;
       }*/

    },
    mounted () {
      this.listMyPractiseInit();
      this.getTrainingNameList();
    },
    watch: {
      bindType: function () {
        this.listMyPractiseInit();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PractiseTablePage.vue